var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"controlchart"}},[_c('b-card',[_c('apexchart',{attrs:{"type":"pie","height":"500","options":_vm.chartOptions,"series":_vm.series}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }